<template>
  <div class="api-detail-container">
    <div class="back">
      <span @click="$router.go(-1)"><i class="iconfont icon-back"></i>返回</span>
    </div>
    <div class="content">
      <div class="form">
          <el-form ref="form" :model="form" :rules="rules"  label-width="160px">
            <el-row :gutter="20">
              <el-col :span="8">
                <el-form-item label="接口名称" prop="api_name">
                    <el-input v-model="form.api_name" placeholder="请输入"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="接口类型" prop="api_type">
                    <el-select v-model="form.api_type" filterable  placeholder="请选择" style="width:100%;">
                      <el-option
                        v-for="item in options.apiOptions"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                      </el-option>
                    </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="8">
                <el-form-item label="接口路径" prop="url">
                    <el-input v-model="form.url" placeholder="请输入"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="请求方式" prop="request_type">
                    <el-select v-model="form.request_type"  placeholder="请选择" style="width:100%;">
                      <el-option
                        v-for="item in options.reqOptions"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                      </el-option>
                    </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="16">
                <el-form-item label="请求参数" prop="resquest_param">
                    <el-table  :data="tableData"
                          border
                          style="width: 100%">
                          <el-table-column
                            prop="paramsK"
                            label="参数名"
                            width="150">
                            <template slot-scope="scope">
                              <el-input v-model="scope.row.paramsK"></el-input>
                            </template>
                          </el-table-column>
                          <el-table-column
                            prop="paramsV"
                            label="参数值"
                            width="200">
                            <template slot-scope="scope">
                              <el-input v-model="scope.row.paramsV"></el-input>
                            </template>
                          </el-table-column>
                          <el-table-column
                            prop="desc"
                            label="描述"
                            width="230">
                            <template slot-scope="scope">
                              <el-input v-model="scope.row.desc"></el-input>
                            </template>
                          </el-table-column>
                          <el-table-column
                            label="操作">
                            <template slot-scope="scope">
                              <el-button @click="addClick(scope.row)" type="text" size="small">添加</el-button>
                              <el-button @click.native.prevent="deleteClick(scope.$index, tableData)" type="text" size="small">删除</el-button>
                            </template>
                          </el-table-column>
                        </el-table>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="16">
                <el-form-item label="返回数据" prop="call_back_data">
                    <el-input type="textarea" :rows="6" v-model="form.call_back_data" placeholder="请输入"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
             <el-row :gutter="20">
              <el-col :span="16">
                <el-form-item label="备注" prop="remark">
                    <el-input type="textarea" :rows="5" v-model="form.remark" placeholder="请输入"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="16">
                <el-form-item label="完成状态" prop="status">
                        <el-radio v-model="form.status" label="0">未完成</el-radio>
                        <el-radio v-model="form.status" label="1">已完成</el-radio>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <div class="btns">
            <el-button type="primary" @click="submitForm('form')">保存信息</el-button>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
import {  GetApiMenu,saveData } from '@/api/api'

export default {
  data() {
    return {
      form: {
        resquest_param:[]
      },
      rules: {
          api_name: [
            { required: true, message: '请输入接口名称', trigger: 'blur' }
          ],
          api_type: [
            { required: true, message: '请选择接口类型', trigger: 'blur' }
          ],
          url: [
            { required: true, message: '请输入接口路径', trigger: 'blur' }
          ],
          request_type: [
            { required: true, message: '请选择请求方式', trigger: 'blur' }
          ],
          call_back_data: [
            { required: true, message: '请输入返回数据', trigger: 'blur' }
          ]
      },
      tableData: [{
          paramsK: '',
          paramsV: '',
          desc: ''
        }],
      options:{
        apiOptions:[],
        reqOptions:[{id:1,name:"GET"},{id:2,name:"POST"}]
      }
    }
  },
  created(){
    this.initAipOptions()
  },
  methods: {
    initAipOptions(){
      GetApiMenu().then(res=>{
          this.options.apiOptions = res.data
      })
    },
    deleteClick(index,rows) {
        if(rows.length > 1){
          rows.splice(index, 1);
        }
    },
    addClick(){
        this.tableData.push({
          paramsK:'',
          paramsV:'',
          desc:''
        })
    },
    // 提交
    submitForm(formName) {
      this.form.resquest_param = this.tableData
      this.$refs[formName].validate((valid) => {
        if (valid) {
            saveData(this.form).then(res=>{
               if(res.code == 0 ){
                  this.$message.success('保存成功!')
                  this.$router.back(-1)
               }else{
                  this.$message.error(res.message)
                  return
               }
          
            })
        } else {
          return false
        }
      })
    },
  }
}
</script>

<style lang="less" scoped>
.api-detail-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding: 20px 20px;
  .back {
    color: #42a3df;
    font-size: 20px;
    font-weight: bold;
    padding-bottom: 10px;
    span {
      cursor: pointer;
    }
    .iconfont {
      margin-right: 10px;
    }
  }
  .content {
    flex: 1;
    min-height: 0;
    width: 100%;
    padding: 20px 20px;
    background: #fff;
    box-shadow: 0 0 6px 1px #acacac;
    overflow-y: auto;
    .cell {
      display: flex;
      padding: 20px 0;
      .label {
        width: 120px;
        text-align: right;
      }
      .value {
        flex: 1;
        margin-left: 40px;
      }
      .code {
        padding: 20px 10px;
        border: 1px solid #eee;
      }
    }
  }
}
 .btns {
        padding: 5px 160px 60px;
      }
</style>
